<template>
  <div>
     <div
        v-if="loader"
        style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);
      "
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10">

      <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center;">
        <v-flex sm3 md4 lg1>
          <v-checkbox
              label="Local"
              :value="filters.local"
              row
              v-model="filters.local"
              @change="local_filter($event)"
              class="request_checkbox"
              :color="'black'"
          ></v-checkbox>
        </v-flex>
        <v-flex sm3 md4 lg1 style="margin-right: 30px;">
          <v-checkbox
              label="Metro"
              :value="filters.metro"
              row
              v-model="filters.metro"
              @change="metro_filter($event)"
              class="request_checkbox"
              :color="'black'"
          ></v-checkbox>
        </v-flex>

        <v-flex sm3 md4 lg1 style="margin-right: 30px;">
          <v-checkbox
              label="Mono"
              :value="filters.mono"
              row
              v-model="filters.mono"
              @change="mono_filter($event)"
              class="request_checkbox"
              :color="'black'"
          ></v-checkbox>
        </v-flex>

        <v-flex sm12 md12 lg4 style="margin-top: 13px;" v-if="filters.local == true">
          <v-autocomplete
              v-model="filters.station"
              :items="local_stations.local_stations"
              placeholder="Search By Station"
              :search-input.sync="search_title"
              item-value="id"
              item-text="name"
              clearable solo flat
              @change="searchByTitle()"
          ></v-autocomplete>
        </v-flex>


        <v-flex sm12 md12 lg4 style="margin-top: 13px;" v-if="filters.metro == true">
          <v-autocomplete
              v-model="filters.station"
              :items="local_stations.metro_stations"
              placeholder="Search By Station"
              :search-input.sync="search_title"
              item-value="id"
              item-text="name"
              clearable solo flat
              @change="searchByTitle()"
          ></v-autocomplete>
        </v-flex>

        <v-flex sm12 md12 lg4 style="margin-top: 13px;" v-if="filters.mono == true">
          <v-autocomplete
              v-model="filters.station"
              :items="local_stations.mono_stations"
              placeholder="Search By Station"
              :search-input.sync="search_title"
              item-value="id"
              item-text="name"
              clearable solo flat
              @change="searchByTitle()"
          ></v-autocomplete>
        </v-flex>
        <v-flex sm12 md6 lg4 style="display: flex; justify-content: center; padding-bottom: 15px;">
          <!--          <v-menu offset-y>-->
          <v-btn
              slot="activator"
              color="rgb(248 71 6)"
              class="white--text add_notification"
          >
            <router-link to="/addstationAdsInventory" class="white--text">
              <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon
              >Create Station Inventory</router-link
            >
          </v-btn>
          <!--          </v-menu>-->
        </v-flex>

      </v-layout>

        <v-dialog
          v-model="delete_model"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to delete the Station Inventory?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="confirmDelete">Delete</v-btn>
              <v-btn
                  small
                  color="black"
                  flat
                  type="reset"
                  @click="delete_model = !delete_model"
              >Cancel</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

       <v-dialog
          v-model="edit_dialog"
          scrollable
          :overlay="false"
          max-width="500px"
          max-height="800px"
          transition="dialog-transition"
      >
        <v-card>
          <v-form
              @submit.prevent="validateBeforeSubmit('updateStationInventory')"
              data-vv-scope="updateStationInventory"
              ref="form"
              v-model="valid"
          >
            <v-card-text>
              <v-card-title primary-title>
                <span class="headline"></span>
              </v-card-title>
              <v-container fluid grid-list-md style="padding: 0 16px 16px 16px">
                <v-layout row wrap>
                   <v-flex xs12 v-if="this.filters.local == true">
                    <v-text-field
                        name="local_station"
                        label="Station Name"
                        v-model="station_inventory_object.local"
                        v-validate="'required'"
                        :disabled="read"
                        :error-messages="errors.collect('updateStationInventory.local_station')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 v-else-if="this.filters.metro == true">
                    <v-text-field
                        name="metro_station"
                        label="Station Name"
                        v-model="station_inventory_object.metro"
                        v-validate="'required'"
                        :disabled="read"
                        :error-messages="errors.collect('updateStationInventory.metro_station')"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs12 v-else-if="this.filters.mono == true">
                    <v-text-field
                        name="Station_name"
                        label="Station Name"
                        v-model="station_inventory_object.mono"
                        v-validate="'required'"
                        :disabled="read"
                        :error-messages="errors.collect('updateStationInventory.Station_name')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        name="Android-ad-unit"
                        label="Android Ads Unit"
                        v-model="station_inventory_object.android_unit"
                        v-validate="'required'"
                        :error-messages="errors.collect('updateStationInventory.Android-ad-unit')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        name="Ios-ad-unit"
                        label="Ios Ads Unit"
                        v-model="station_inventory_object.ios_unit"
                        v-validate="'required'"
                        :error-messages="errors.collect('updateStationInventory.Ios-ad-unit')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" type="submit">Submit</v-btn>
              <v-btn small flat @click="edit_dialog = !edit_dialog">Cancel</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-data-table
        no-results-text="Loading... Please wait"
        :headers="headers"
        :items="station_ads_inventory_list"
        :pagination.sync="pagination"
        :loading="loaders.notification_list_loader"
        :total-items="total_items"
        :rows-per-page-items="[10, 20, 50, 100]"
      >
        <template v-slot:headers="props">
          <tr>
            <th
              style="width: 27%"
              v-for="header in props.headers"
              :key="header.text"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td v-if="filters.local == true">
            
            {{ props.item.local_station.name }}
            
          </td>
          <td v-else-if="filters.metro == true"> 
            {{props.item.metro_station.name}}
          </td>
          <td v-else-if="filters.mono == true"> 
            {{props.item.mono_station.name}}
          </td>
          
          <td>{{ props.item.android_unit_id }}</td>
          <td>{{ props.item.ios_unit_id }}</td>
          <td> 
            <v-flex xs6>
                     <v-sheet class="pa-1">
                       <v-switch
                            :input-value="props.item.is_enabled"
                            :v-model="status"
                            @change="changeState(props.item.id,$event)"
                            color="#fd8955"
                            v-bind="attrs"
                            v-on="on"
                            inset
                            :label="`${props.item.is_enabled == 1 ? 'Active' : 'Inactive' .toString()}`"
                      ></v-switch>
                      </v-sheet>
            </v-flex>
          </td>
          <td>{{ props.item.updated_at | appDateTimeFormat}}</td>
          <td class='pa-1'>
             <v-layout row>
                <v-btn small color="primary" class="white--text elevation-5" @click="stationInventoryDetails(props.item)">Edit</v-btn>
                <v-btn small color="#F84706" class="white--text elevation-5" @click="stationInventoryDelete(props.item.id)">Delete</v-btn>
            </v-layout>
          </td>
        </template>
        <template slot="no-data">
          <v-layout
            row
            wrap
            justify-center
            class="text-xs-center"
            v-if="loaders.notification_list_loader"
          >
            Loading... Please wait
          </v-layout>
          <v-layout row wrap justify-center class="text-xs-center" v-else>
            No data available
          </v-layout>
        </template>
      </v-data-table>
       <v-snackbar
          :color="snack_bar.color"
          :top="snack_bar.top"
          :bottom="snack_bar.bottom"
          :left="snack_bar.left"
          :right="snack_bar.right"
          v-model="snack_bar.show"
      >
        {{ snack_bar.message }}
        <v-btn dark flat @click.native="snack_bar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Index",
  data: () => {
    return {
      headers: [
        {
          text: "Station",
          value: "station",
          align: "left",
          sortable: false,
        },
        {
          text: "Android-ad-unit",
          value: "android-ad-unit",
          sortable: false,
        },
        {
          text: "Ios-ad-unit",
          value: "ios-ad-unit",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
        },
        {
          text: "Updated At",
          value: "updated_at",
          sortable: false,
        },
         {
          text: "Action",
          value: "action",
          sortable: false,
        },
      ],
      loaders: {
        notification_list_loader: false,
      },
      station_ads_inventory_list: [],
      updated_at_datetime: [],
      station_inventory_object:{},
      local_stations:[],
      api_type:"web",
      loader: false,
      total_items: 0,
      status: true,
      edit_dialog:false,
      delete_model:false,
        read:true,
        snack_bar: {
        show: false,
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
        color: "",
      },  
      titles: [],
      title_type: [],
      title_list: [],
      title_searched: "",
      search_title: "",
      pagination: { sortBy: "created_at", descending: false, rowsPerPage: 10 },
      filters: {
        station:"",
        local:true,
        metro:false,
        mono:false,
      },
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      },
    },
   
    "filters.station": {
      handler(value) {
        if (value == undefined) {
          this.filters.station = "";
          this.getList();
        }
      },
    },
   
   
  },
  methods: {

    local_filter:function(active){
        this.filters.metro = false;
        this.filters.mono = false;
        this.filters.local = active;
        this.getList();
    },

    metro_filter:function(active){
        this.filters.local = false;
        this.filters.mono = false;
        this.filters.metro = active;
        this.getList();
    },

    mono_filter:function(active){
        this.filters.local = false;
        this.filters.metro = false;
        this.filters.mono = active;
        this.getList();
    },

    searchByTitle:function(){
        this.getList();
    },

    changeState: function(station_id,status_id){
      this.loader = true;
      let station_inventory_status_update = {};
      station_inventory_status_update.id = station_id;
      station_inventory_status_update.status = status_id;
       
        axios
          .post(
              `${process.env.VUE_APP_API_URL}/api/v1/update-station-inventory-status`,station_inventory_status_update,
              { headers: this.$headers }
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.loader = false;
              this.snack_bar.message = response.data.message;
              this.snack_bar.show = true;
              this.getList();
            }
          })
          .catch((error) => {})
          .finally(() => {}); 


    },

    stationInventoryDelete: function(stationInventoryID){
      this.station_inventory_object.id = stationInventoryID;
      this.delete_model=true;
    },
     confirmDelete: function () {
      this.loader = true;
      axios
          .post(
              `${process.env.VUE_APP_API_URL}/api/v1/delete-station-inventory`,
              { station_inventory_id: this.station_inventory_object.id},
              { headers: this.$headers }
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.loader = false;
              this.delete_model = false;
              this.snack_bar.message = response.data.message;
              this.snack_bar.show = true;
              this.getList();
            }
          })
          .catch((error) => {})
          .finally(() => {});
    },

      validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },

     stationInventoryDetails: function(stationInventory){
      // console.log(stationInventory);return;

      this.station_inventory_object.station_id   = stationInventory.id; 
      if(stationInventory.rail_type_id  == 1){
           if(stationInventory.local_station.name != null){
             this.station_inventory_object.local = stationInventory.local_station.name;
              
           }
             
      }
      if(stationInventory.rail_type_id  == 2){
           if(stationInventory.metro_station.name != null){
             this.station_inventory_object.metro = stationInventory.metro_station.name;
             
           }
             
      }
       if(stationInventory.rail_type_id  == 3){
           if(stationInventory.mono_station.name != null){
             this.station_inventory_object.mono = stationInventory.mono_station.name;
             
           }
             
      }
      // if(stationInventory.metro_station.name != null){
      //     this.station_inventory_object.metro = stationInventory.metro_station.name;
      //     console.log(this.station_inventory_object.metro);
      //   }
      // }if(stationInventory.mono_station.name != null){
      //     this.station_inventory_object.mono = stationInventory.mono_station.name;
      // }

      this.station_inventory_object.android_unit = stationInventory.android_unit_id;
      this.station_inventory_object.ios_unit     = stationInventory.ios_unit_id;
      this.edit_dialog=true;
     },

     updateStationInventory: function(){
     this.loader =  true; 
     let new_station_inventory = {};
     new_station_inventory.station_id = this.station_inventory_object.station_id;
     new_station_inventory.android_unit = this.station_inventory_object.android_unit;
     new_station_inventory.ios_unit = this.station_inventory_object.ios_unit; 
     
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-station-inventory`, new_station_inventory,{ headers: this.$headers }).then((response)=>{
        if(response.data.status == 1)
        {

         
          this.edit_dialog=false;
          this.loader=false;
          this.snack_bar.message = response.data.message;
          this.snack_bar.show = true;
          this.getList();
          // this.$router.push({name:"StationAdsInventoryList"});  
        }
        else
        {
          this.snackBar.message = response.data.message;
          this.snackBar.show = true;
        }

      }).catch((error)=>{
        console.log(error);
      }).finally(()=>{
        this.loader =  false;
      });  
     },

    getStations: function(){

       axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/local-station`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
                
                this.local_stations = response.data.stations;
                   
             }  
        })
    },

   
    getList: function () {
      this.loaders.notification_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
        .get(`${process.env.VUE_APP_API_URL}/api/v1/station-ad-inventory`, {
          headers: this.$headers,
          params: {'api_type':this.api_type,'params':this.pagination},
        })
        .then((response) => {
          if (response.data.status == 1) {
            
           // console.log(response.data.station_ad_inventory);return; 
            this.station_ads_inventory_list = response.data.station_ad_inventory;
             
          }
        })
        .catch((error) => {
          console.log(error);
          this.snack_bar.message = "Error Occured";
          this.snack_bar.show;
        })
        .finally(() => {
          {
            this.loaders.notification_list_loader = false;
          }
        });
      this.is_loading = false;
    },
    getTitlesList: function (newVal) {
      this.loaders.notification_list_loader = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/v1/notification-filter-title`,
          { headers: this.$headers, params: { searched_title: newVal } }
        )
        .then((response) => {
          if (response.data.status == 1) {
            this.title_list = response.data.titles;
          }
        })
        .catch((error) => {
          console.log(error);
          this.snack_bar.message = "Error Occured";
          this.snack_bar.show;
        })
        .finally(() => {
          {
            this.loaders.notification_list_loader = false;
          }
        });
      this.is_loading = false;
    },
  },
  mounted() {
    this.getList();
    this.getStations();
  },
};
</script>

<style>
.add_notification {
  background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%);
}

</style>

